//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	gap: 10px;
	min-height: calc(100vh - 72px);
	& > *:nth-child(3) {
		align-self: flex-start;
	}
`;
export const Content = styled.section`
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: center;
	width: 75%;
	margin-top: 18px;
	margin-bottom: 15px;
	flex-grow: 1;
	@media (max-width: 1100px) {
		width: 90%;
	}
	& h3 {
		margin-right: auto;
	}
	& h5 {
		margin-right: auto;
	}
`;
export const Fields = styled.section`
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 100%;
`;
export const AddStudentField = styled.section`
	display: flex;
	align-items: end;
	width: 100%;
	gap: 10px;
	& > *:first-child {
		width: 100%;
	}
	& button {
		padding-left: 25px;
		padding-right: 25px;
	}
`;
export const Header = styled.header`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	width: 100%;
	margin-bottom: 10px;
	& h2 {
		margin: 0;
		font-size: 20px;
	}
	& h3 {
		font-size: 18px;
		margin: 0;
	}
	& h4 {
		color: var(--light-gray-5);
		font-size: 14px;
		display: flex;
		justify-content: center;
		gap: 10px;
		margin: 0;
	}
`;
export const Footer = styled.footer`
	display: flex;
	justify-content: space-between;
	width: 100%;
	background-color: var(--light-1);
	padding: 14px 28px;
`;
export const ContentResultSearchStudentById = styled.article`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 400px;
	&.not-found img.not-found-image {
		width: 150px;
	}
	h3,
	h4 {
		font-weight: 900;
		margin: 0;
		text-align: center;
	}
	& > .title {
		margin-top: 20px;
	}
	h5 {
		margin-top: 10px;
		font-size: 14px;
		font-weight: 400;
	}
`;
